module.exports = __webpack_public_path__ + "static/media/FlightLogsInactive.4eabad0b.svg";